<header class="header-mobile flex-between">
    <a class="header-mobile__logo" aria-label="Navigate to dashboard" (click)="redirectToRoleRespectiveDashboard()">
        <img class="logo" alt="Trinity medical solutions logo" src="assets/img/v2/general/logo-dark.svg" />
    </a>

    <button mat-icon-button class="header-mobile__toggle flex-center" (click)="toggleIsMenuOpen()">
        <mat-icon class="header-mobile__toggle-icon flex-center" [ngClass]="{ 'header-mobile__toggle-icon--animated': isMenuOpen }">
            {{ isMenuOpen ? 'close' : 'menu' }}
        </mat-icon>
    </button>
</header>
